import React, { useEffect, useState } from 'react'
import { Global } from '../Variables/Global';
import { FaListUl, FaGripHorizontal } from 'react-icons/fa';
import ProductGrid from '../Common/ProductGrid';
import ProductList from '../Common/ProductList';
import Util from '../../Classes/Utils';
import { useNavigate, useParams } from 'react-router-dom';
import Category from '../Category/Category';
import Pagination from '../Pagination/Pagination'
import ProductModal from '../Common/ProductModal';
import { toast } from 'react-toastify';
import { AddItemToWishList, GetWishListItems, RemoveItemFromWishList, getProductsByCategoryId } from '../Data';
import Cookies from 'js-cookie';

const ListProduct = () => {
	const [isLogged, setIsLogged] = useState(false);
	const [showList, setShowList] = useState("grid");
	const [showModal, setShowModal] = useState(false);
	const [listProductLoading, setListProductLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [productDetails, setProductDetails] = useState();
	const [WishListItems, setWishListItems] = useState([]);
	const [categoryProducts, setCategoryProducts] = useState({
		Products: [],
		ProductsCount: 0
	});
	const navigate = useNavigate();
	const token = Cookies.get("CustomerToken");
	const params = useParams();
	let LIMIT = 9;

	const getProductByCategoryId = async () => {
		const groupId = Cookies.get("WishList") !== undefined ? 4 : 3;

		const result = await getProductsByCategoryId(
			params.CategoryId,
			groupId,
			currentPage,
			LIMIT
		);

		setCategoryProducts({
			Products: result.finalList || [],
			ProductsCount: result.ProductCount || 0
		});
	};

	const GetWishListItemsForShop = () => {
		var groupId;
		if (Cookies.get("WishList") !== undefined) {
			groupId = 4
		} else {
			groupId = 3
		}
		const getItem = (Cookies.get('WishList') !== undefined);
		if (getItem) {
			var WishlistId = Cookies.get("WishList");
			GetWishListItems(WishlistId, groupId, token).then((Result) => {
				setWishListItems(Result.WishlistItems);
			});
		}
	}
	const HandleAddToWishList = (ProductId, ProductVariationId) => {
		if (!isLogged) {
			navigate('/Authentication');
			return;
		}

		const WishlistId = Cookies.get("WishList");
		if (!WishlistId) return;

		AddItemToWishList(WishlistId, ProductId, ProductVariationId, token)
			.then(response => {
				if (!response.ok) throw new Error();
				return response.json();
			})
			.then(() => {
				toast.success("Item added to wishList");

				// ✅ UPDATE STATE
				setWishListItems(prev => [
					...prev,
					{
						ProductId,
						DefaultProductVariationId: ProductVariationId
					}
				]);
			})
			.catch(() => {
				toast.error("Could Not Add");
			});
	};


	const HandleRemoveFromWishList = (ProductId) => {
		if (!isLogged) {
			navigate('/Authentication');
			return;
		}

		const WishlistId = Cookies.get("WishList");
		if (!WishlistId) return;

		RemoveItemFromWishList(ProductId, WishlistId, token)
			.then(response => {
				if (!response.ok) throw new Error();
				return response.json();
			})
			.then(() => {
				toast.success("Item Removed from wishList");

				// ✅ UPDATE STATE
				setWishListItems(prev =>
					prev.filter(item => item.ProductId !== ProductId)
				);
			})
			.catch(() => {
				toast.error("Could Not Remove");
			});
	};

	const handleCategoryChange = () => {
		setCurrentPage(1);        // ✅ reset pagination
		window.scrollTo({ top: 0, behavior: 'smooth' }); // ✅ scroll top
	};

	useEffect(() => {
		setListProductLoading(true);
		setIsLogged(!!Cookies.get("CustomerToken"));

		getProductByCategoryId();
		GetWishListItemsForShop();

		const timer = setTimeout(() => {
			setListProductLoading(false);
		}, 600);

		return () => clearTimeout(timer);
	}, [params.CategoryId, currentPage]);

	return (
		<>
			{
				listProductLoading ? (
					<div className="spinner-container">
						<div className="loading-spinner"></div>
					</div>
				) : (
					<>
						<div className="breadcrumb-area mb-5">
							<div className="container">
								<div className="row">
									<div className="col">
										<div className="breadcrumb-container HomeShop">
											<ul>
												<li><a href="index.html"><i className="fa fa-home"></i> Home</a></li>
												<li className="active">{params.CategoryName}</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="shop-page-container mb-5">
							<div className="container">
								<div className="row">
									<div className="col-lg-4 order-2 order-lg-1">
										<div className="sidebar-area">
											<div className="sidebar mb-3">
												<Category onCategoryClick={handleCategoryChange} />
												<ul className="product-categories">
												</ul>
											</div>
											<div className="">
											</div>
										</div>
									</div>
									<div className="col-lg-8 order-1 order-lg-2 mb-sm-35 mb-xs-3">
										<div className="shop-header mb-3 mt-2">
											<div className="row">
												<div className="col-lg-4 col-md-4 col-sm-12 d-flex align-items-center">
													<div className="view-mode-icons mb-xs-10 directionLtr">
														<a className={showList.includes("grid") ? "active" : ""} data-target="grid" onClick={() => setShowList('grid')}><FaGripHorizontal /></a>
														<a className={showList.includes("list") ? "active" : ""} data-target="list" onClick={() => setShowList('list')}><FaListUl /></a>
													</div>
												</div>
												<div className="col-lg-8 col-md-8 col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-left align-items-sm-center">
													<div className="sort-by-dropdown d-flex align-items-center mb-xs-10">
													</div>
												</div>
											</div>
										</div>
										<div className={"shop-product-wrap row no-gutters mb-3 " + showList} >
											{
												categoryProducts.Products.length > 0 ? (
													categoryProducts.Products.map((product, index) => {
														return (
															<div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
																<ProductGrid
																	product={product}
																	WishListItems={WishListItems}
																	HandleAddToWishList={HandleAddToWishList}
																	HandleRemoveFromWishList={HandleRemoveFromWishList}
																	setShowModal={setShowModal}
																	productDetails={productDetails}
																	setProductDetails={setProductDetails}
																/>
																<ProductList
																	product={product}
																	WishListItems={WishListItems}
																	HandleAddToWishList={HandleAddToWishList}
																	HandleRemoveFromWishList={HandleRemoveFromWishList}
																	setShowModal={setShowModal}
																	productDetails={productDetails}
																	setProductDetails={setProductDetails} />
																{
																	showModal && (
																		<ProductModal
																			WishListItems={WishListItems}
																			HandleAddToWishList={HandleAddToWishList}
																			HandleRemoveFromWishList={HandleRemoveFromWishList}
																			productDetails={productDetails}
																			showModal={showModal}
																			setShowModal={setShowModal}
																		/>
																	)
																}
															</div>
														)
													})
												) : (
													<h1 className='mt-5'>No Prodcut Found</h1>
												)
											}
										</div>
										{
											categoryProducts.Products.length > 0 && (
												<Pagination
													currentPage={currentPage}
													totalCount={categoryProducts.ProductsCount}
													pageSize={LIMIT}
													onPageChange={page => setCurrentPage(page)}
												/>
											)
										}
									</div>
								</div>
							</div>
						</div>
					</>
				)
			}
		</>
	)
}

export default ListProduct